import { Form, FormFieldType } from "@/forms/Form";

export class PhoneDataForm extends Form {
  public definition = { };
}
